/**
 * Search widget component.
 * @module components/theme/SearchWidget/SearchWidget
 */

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form, Input } from 'semantic-ui-react';
import { compose } from 'redux';
import { PropTypes } from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import { Icon } from '@plone/volto/components';
import zoomSVG from '@plone/volto/icons/zoom.svg';

import config from '@plone/volto/registry';

const messages = defineMessages({
  search: {
    id: 'Search',
    defaultMessage: 'Search',
  },
  searchSite: {
    id: 'Search Site',
    defaultMessage: 'Search Site',
  },
});

/**
 * SearchWidget component class.
 * @class SearchWidget
 * @extends Component
 */
class SearchWidget extends Component {
  /**
   * Property types.
   * @property {Object} propTypes Property types.
   * @static
   */
  static propTypes = {
    pathname: PropTypes.string.isRequired,
    useSection: PropTypes.bool,
    onSubmitOrEsc: PropTypes.func,
  };

  static defaultProps = {
    useSection: false,
  };

  /**
   * Constructor
   * @method constructor
   * @param {Object} props Component properties
   * @constructs WysiwygEditor
   */
  constructor(props) {
    super(props);
    this.onChangeText = this.onChangeText.bind(this);
    this.onChangeSection = this.onChangeSection.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      text: '',
      section: this.props.useSection,
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onEscape, false);
    document
      .querySelector('.ui.form .searchbox.field button')
      .addEventListener('keydown', this.closeOnTab, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onEscape, false);
    document
      .querySelector('.ui.form .searchbox.field button')
      .removeEventListener('keydown', this.closeOnTab, false);
  }

  onEscape = ({ keyCode }) => {
    if (keyCode === 27) this.props.onSubmitOrEsc();
  };
  closeOnTab = (e) => {
    if (e.key === 'Tab') {
      this.props.onSubmitOrEsc();
    }
  };

  /**
   * On change text
   * @method onChangeText
   * @param {object} event Event object.
   * @param {string} value Text value.
   * @returns {undefined}
   */
  onChangeText(event, { value }) {
    this.setState({
      text: value,
    });
  }

  /**
   * On change section
   * @method onChangeSection
   * @param {object} event Event object.
   * @param {bool} checked Section checked.
   * @returns {undefined}
   */
  onChangeSection(event, { checked }) {
    this.setState({
      section: checked,
    });
  }

  /**
   * Submit handler
   * @method onSubmit
   * @param {event} event Event object.
   * @returns {undefined}
   */
  onSubmit(event) {
    this.props.onSubmitOrEsc && this.props.onSubmitOrEsc();

    let section = this.state.section
      ? `&path=${this.props.pathname}`
      : config.settings.isMultilingual
      ? `&path=${this.props.lang}`
      : null;

    this.props.history.push(
      `${this.props.intl.locale}/search?SearchableText=${this.state.text}${section}`,
    );
    event.preventDefault();
  }

  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */
  render() {
    return (
      <Form action="/search" onSubmit={this.onSubmit}>
        <Form.Field className="searchbox">
          <Input
            aria-label={this.props.intl.formatMessage(messages.search)}
            onChange={this.onChangeText}
            name="SearchableText"
            value={this.state.text}
            transparent
            placeholder={this.props.intl.formatMessage(messages.searchSite)}
            title={this.props.intl.formatMessage(messages.search)}
          />
          <button
            aria-label={this.props.intl.formatMessage(messages.search)}
            title={this.props.intl.formatMessage(messages.search)}
          >
            <Icon name={zoomSVG} size="18px" />
          </button>
        </Form.Field>
      </Form>
    );
  }
}

export default compose(
  withRouter,
  injectIntl,
  connect((state, props) => {
    return {
      lang: state.intl.locale,
    };
  }),
)(SearchWidget);
